import seedrandom from "seedrandom"

export function createSeededRNG(seed: string) {
  return seedrandom(seed)
}
